import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import { Button } from 'semantic-ui-react';
import VSvgToolbar from '../VSvg/VSvgToolbar';
import VImageToolbar from '../VImage/VImageToolbar';
import VFrameToolbar from '../VFrame/VFrameToolbar';
import VEditorToolbar from '../VTextEditor/VEditorToolbar';
import VLineToolbar from '../VLine/VLineToolbar';
import BackgroundToolbar from '../Background/BackgroundToolbar';
import Flipper from '../Flipper/Flipper';
import Opacity from '../Opacity/Opacity';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import { useTranslation } from 'react-i18next';
import Position from '../Position/Position';
import { ReactSVG } from 'react-svg';
import { isMobileOnly } from 'react-device-detect';
import * as icons from '../../assets/images/toolbarIcons/_toolbarIcons';
import _ from 'lodash';
import './VToolbar.css';

const Toolbar = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedEntity = useSelector(state => state.design.selectedEntity);
  const { activePageRef } = useContext(DesignContext);

  const deleteEntity = () => {
    if (selectedEntity.type === 'Background') {
      dispatch(designActions.deletePageBackground(activePageRef.current));
    } else if (
      selectedEntity.type === 'ImageBackground' ||
      selectedEntity.type === 'VideoBackground'
    ) {
      dispatch(designActions.deletePageBackground(activePageRef.current));
      dispatch(
        designActions.changeSelectedEntity({ id: `-${activePageRef.current}`, type: 'Background' }),
      );
    } else {
      const deletedEntities = Array.isArray(selectedEntity.id)
        ? selectedEntity.id.map(String)
        : [selectedEntity.id.toString()];
      dispatch(designActions.deleteEntity(activePageRef.current, deletedEntities));
    }
  };

  const groupEntities = createGroup => {
    console.log('>> groupEntities', createGroup);
    const groupEntities = Array.isArray(selectedEntity.id)
      ? selectedEntity.id.map(String)
      : [selectedEntity.id.toString()];
    const groupsCount = document.querySelectorAll('.groupMoveable').length;
    console.log('groupEntities', groupEntities);
    console.log('groupsCount', groupsCount);
    dispatch(designActions.groupEntities(activePageRef.current, groupEntities, groupsCount));
  };

  const lockEntity = () => {
    dispatch(designActions.changeEntityLockState(selectedEntity.id, true));
  };
  const unlockEntity = () => {
    dispatch(designActions.changeEntityLockState(selectedEntity.id, false));
  };

  // const addLinkToEntity = () => {};

  // const transparentEntity = () => {};

  // const copyEntityStyle = () => {};

  const duplicateEntity = () => {
    const selectedEntities = Array.isArray(selectedEntity.id)
      ? selectedEntity.id
      : [selectedEntity.id];
    dispatch(designActions.duplicateEntity(activePageRef.current, selectedEntities));
  };

  let tools = [];
  let selectedEntityId;
  const pageId = activePageRef.current;

  if (selectedEntity) {
    if (selectedEntity.type === 'Background') {
      selectedEntityId = -1;
    } else {
      selectedEntityId = selectedEntity.id;
    }
    if (selectedEntity.type !== 'CropMode' && !selectedEntity.lock) {
      const type = selectedEntity.type ? _.get(selectedEntity, 'type', '') : '';
      tools.push(
        <div className="publicTools" key={1}>
          <Button title="Delete" onMouseDown={deleteEntity}>
            <ReactSVG src={icons.delete} />
          </Button>
          {!type.includes('Background') && (
            <Button title="Duplicate" icon="clone outline" onMouseDown={duplicateEntity} />
          )}

          <Button title="Lock" onMouseDown={lockEntity}>
            <ReactSVG src={icons.lock} />
          </Button>
          {!type.includes('Group') && type !== 'Background' && (
            <Opacity targetId={selectedEntityId} pageId={pageId} />
          )}
          {type.includes('Group') && (
            <>
              {/* <Button content={t('group')} onMouseDown={() => groupEntities(true)} />
              <Button content={t('ungroup')} onMouseDown={() => groupEntities(false)} /> */}
            </>
          )}
          {!type.includes('Background') && <Position />}
          {selectedEntity.type !== 'Text' &&
            !type.includes('Group') &&
            selectedEntity.type !== 'Background' &&
            selectedEntity.type !== 'Line' && (
              <Flipper
                targetId={selectedEntityId}
                targetType={selectedEntity.type}
                pageId={pageId}
              />
            )}
          {isMobileOnly && (selectedEntity.type === 'Image' || selectedEntity.type === 'Video') && (
            <Button
              content={t('replace')}
              onMouseDown={() => dispatch(designActions.changeReplaceEntityState(true))}
            />
          )}
        </div>,
      );
    }
    if (selectedEntity.lock) {
      tools.push(
        <Button title="Lock" onMouseDown={unlockEntity}>
          <ReactSVG src={icons.unlock} />
        </Button>,
      );
    }

    switch (!selectedEntity.lock && selectedEntity.type) {
      case 'Text':
        tools.push(<VEditorToolbar key={2} selectedEditorId={selectedEntityId} />);
        break;
      case 'TextGroup':
        tools.push(
          <VEditorToolbar key={2} selectedEditorId={selectedEntityId[0]} ids={selectedEntityId} />,
        );
        break;
      case 'Image':
        tools.push(<VImageToolbar key={2} selectedEntity={selectedEntityId} />);
        break;
      case 'Video':
        tools.push(<VImageToolbar key={2} selectedEntity={selectedEntityId} />);
        break;
      case 'Shape':
        tools.push(<VSvgToolbar key={2} selectedEntity={selectedEntityId} />);
        break;
      case 'Vector':
        tools.push(<VSvgToolbar key={2} selectedEntity={selectedEntityId} />);
        break;
      case 'Background':
        tools.push(<BackgroundToolbar key={2} selectedEntity={selectedEntityId} />);
        break;
      case 'Line':
        tools.push(<VLineToolbar key={2} selectedEntity={selectedEntityId} />);
        break;
      case 'Frame':
        tools.push(<VImageToolbar key={2} selectedEntity={selectedEntityId} />);
        tools.push(<VFrameToolbar key={3} selectedEntity={selectedEntityId} />);
        break;
      case 'ImageBackground':
      case 'VideoBackground':
        tools.push(<VImageToolbar key={2} selectedEntity={selectedEntityId} />);
        tools.push(<BackgroundToolbar key={3} selectedEntity={selectedEntityId} />);
        break;
      default:
        break;
    }
  }

  return tools && tools.map(tool => tool);
};

export default Toolbar;
